import { cellsCount, tableCellWidthMap } from '../DocumentExpirationDates.constants';

const gap = '32px';
const totalGap = `calc(${gap} * ${cellsCount - 1})`;
const gridTemplateColumns = Object.values(tableCellWidthMap)
  .map(cellWidth => `calc((${parseFloat(cellWidth)} * (100% - ${totalGap})) / 100)`)
  .join(' ');

export const wrapperStyles = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns,
  alignItems: 'center',
  gap,
};

export const titleCellStyles = {
  '& .table-cell__content_box': {
    overflow: 'visible',
  },
};
